function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#FFC107",
  d: "M12.62 1.219C12.304.293 11.257-.214 10.282.087c-.975.3-1.507 1.295-1.19 2.222l4.796 14.028c.33.865 1.312 1.352 2.257 1.094.984-.27 1.586-1.263 1.27-2.182-.01-.036-4.795-14.03-4.795-14.03z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#4CAF50",
  d: "M6.12 3.72c-.317-.927-1.364-1.435-2.337-1.133-.974.302-1.509 1.296-1.191 2.222l4.796 14.028c.33.865 1.312 1.352 2.257 1.094.984-.27 1.586-1.263 1.27-2.182-.01-.035-4.795-14.03-4.795-14.03z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#EC407A",
  d: "M18.781 12.62c.927-.317 1.433-1.363 1.132-2.338-.3-.975-1.295-1.507-2.222-1.19L3.663 13.888c-.865.329-1.352 1.312-1.094 2.257.27.984 1.263 1.585 2.182 1.27l14.03-4.796z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#472A49",
  d: "M6.604 17L10 15.896 8.896 12.5 5.5 13.604 6.604 17z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#CC2027",
  d: "M13.604 14.5c1.284-.417 2.477-.804 3.396-1.104L15.896 10 12.5 11.104l1.104 3.396z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#2196F3",
  d: "M16.281 6.12c.927-.316 1.433-1.363 1.132-2.338-.3-.975-1.295-1.507-2.222-1.19L1.163 7.387C.297 7.718-.189 8.701.07 9.646c.27.984 1.264 1.584 2.183 1.27l14.03-4.796z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#1A937D",
  d: "M4.103 10L7.5 8.896 6.396 5.5 3 6.604 4.103 10z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#65863A",
  d: "M11.104 7.5L14.5 6.396C14.083 5.112 13.694 3.92 13.396 3L10 4.104 11.104 7.5z"
}));

var SvgIconSlack = function SvgIconSlack(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "svg-icon icon-slack",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconSlack, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-slack.36ae0dac.svg";
export { ForwardRef as ReactComponent };